export default __webpack_public_path__ + "static/pay-banner-2-e6138078a574535ba36c0332ad8bae34.jpeg";